import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamARAE() {
  const html = document.documentElement;

  // 设置 lang 属性
  html.setAttribute('lang', 'ar-AE');

  // 根据语言设置 dir (方向)
  // 常见的 RTL 语言：乌尔都语、阿拉伯语等
  html.setAttribute('dir', 'rtl');
  return (
    <div className={styles['declaration']}>
      <h1>بيان الامتثال لعمليتي تدريب أعضاء فريق العمل الميداني واختبارهم</h1>

      <p>
        من أجل مواصلة العمل على تحسين جودة الخدمات التي تقدمها الجهات الترويجية الخارجية مباشرةً للعملاء، يقدم فريق التدريب التابع للإدارة الدولية لدى Xiaomi (يُشار إليه فيما يلي بالضمير "نحن" أو ضمير المتكلم المتصل "نا" أو بلفظ "شركتنا") للجهات الترويجية الخارجية (ويُشار إليها فيما يلي بلفظ "المتدربين أو المتدربون") دورات تدريبية واختبارات مصاحبة لها لتعزيز المعرفة لديها، والتي يحددها مقدمو خدمات التعهيد. ويتمثل الهدف من عمليتي التدريب والاختبار في تحسين محتوى الدورات وترسيخ نتائج التعلم، وهما لا تشكلان أي شكل من أشكال علاقات العمل أو السلوك الإداري الفعلي. ويرد فيما يلي بيان بشأن عمليتي التدريب والاختبار:
      </p>

      <ol>
        <li>
          <strong>طبيعة عمليتي التدريب والاختبار</strong><br/>
          تُجرى جميع الدورات التدريبية والاختبارات بغرض مشاركة المعرفة، إذ تهدف إلى مساعدة المتدربين على أن يفهموا بشكل منهجي المعلومات المتعلقة بالمنتجات ومعايير الخدمات المقدمة وما إلى ذلك. ولا تعكس نتائج الاختبارات إلا مدى استيعاب المتدربين لمحتوى التدريب، كما أنها لا تشكل أساسًا لتقييم الأداء. ويُرجى العلم أننا لا نملك الصلاحية ولن نتدخل في أي عملية تقييم للأداء يجريها مقدمو خدمات التعهيد أو توزيع للرواتب أو أي مسائل أخرى تتعلق بالعمل وتخص المتدربين.
        </li>
        <li>
          <strong>توضيح العلاقة القانونية</strong><br/>
          لا يؤثر برنامج التدريب والاختبار هذا على علاقة صاحب العمل والموظف التي تجمع بين المتدربين ومقدمي خدمات التعهيد لهم. ولا توجد علاقة صاحب عمل وموظف بين شركتنا والمتدربين، كما لا تنشأ عن برنامج مشاركة المعرفة والاختبار هذا أي علاقة عمل فعلية مع المتدربين. وتظل حقوق العمل والتزاماته حصرًا بين مقدمي خدمات التعهيد والمتدربين.
        </li>
        <li>
          <strong>استخدام نتائج الاختبارات</strong><br/>
          لا تُستخدم نتائج الاختبارات إلا للأغراض التالية فقط:
          <ol type="1">
            <li>أن تكون بمثابة مرجع لتحقيق الاستفادة القصوى من الدورات الداخلية التي تقدمها شركتنا وتحسينها؛</li>
            <li>وأن تُقدَّم لمقدمي خدمات التعهيد باعتبارها دليل على ما يتمتع به المتدربون من كفاءة مهنية، مع مراعاة تقديرهم المستقل لمقدمي خدمات التعهيد ورغبتهم الخاصة؛</li>
            <li>وألا يُعلَن عن نتائج الاختبارات أو يُفصح عنها لأي جهة خارجية.</li>
          </ol>
        </li>
      </ol>

      <p>
        يدخل البيان الماثل حيز التنفيذ من تاريخ نشره. ويُرجى العلم أن المشاركة في برنامج التدريب والاختبار تشكل إقرارًا من المتدربين بالبيان الماثل وموافقةً منهم عليه. وتحتفظ شركتنا بالحق في تفسير البيان الماثل وقد تعدله بشكل معقول من حين لآخر، شريطة ألا تغيِّر مثل هذه التعديلات من الطبيعة غير الوظيفية لهذا التدريب والاختبار. وفي حالة وجود أي اختلاف أو عدم اتساق بين النسخ الصادرة بلغات مختلفة، يُعمل بالنسخة الصادرة باللغة الإنجليزية.
      </p>

      <div className={styles["footer"]}>
        فريق التدريب التابع للإدارة الدولية لدى Xiaomi<br/>
        التاريخ: {getLocalizedTime('ar-AE')}
      </div>
    </div>
  );
}